const typographyMyComp = {
  company: 'My business',
  profileError: 'wait for the file to upload',
  user: 'Number of Users:',
  userValue: '6 (60%)',
  plan: 'Data consumption:',
  planValue: '32,5 GB (73%)',
  contract: 'Contracted Plan:',
  contractValue: '10 users/50 GB',
  formLabelTitle: 'Contracting the plan:',
  formLabelValue: '10/08/2019 às 08:23 (3 meses)'
};

export default typographyMyComp;
